const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

const textValuesUI = {
  type: uiTypes.TEXT,
  validation: [],
  list: false,
  read: true,
  create: true,
  edit: true,
};

const obj = {
  tableName: "developers",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false,
  references: [
    {
      tableName: "country_cites",
      foreignKey: "country_city_id",
      primaryKey: "id",
      type: referenceTypes.ONE,
      displayKey: "name",
    },
  ],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        type: uiTypes.TEXT,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "name",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.required],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
      },
    },
    {
      name: "description",
      type: types.TEXT,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        type: uiTypes.TEXT_AREA,
        validation: [],
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
    {
      name: "country_city_id",
      type: types.UUID,
      validation: [validatorTypes.uuid, validatorTypes.required],
      ui: {
        type: uiTypes.DROPDOWN,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "image_url",
      type: types.STRING,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.url, validatorTypes.optional],
      ui: {
        type: uiTypes.DOCUMENT,
        validation: [],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "email",
      type: types.STRING,
      validation: [validatorTypes.email, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        read: false,
        create: false,
        edit: false,
      },
    },
    {
      name: "phone",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        read: false,
        create: false,
        edit: false,
      },
    },
    {
      name: "website_url",
      type: types.STRING,
      validation: [validatorTypes.url, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "priority",
      type: types.INTEGER,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.isInteger, validatorTypes.optional],
      ui: {
        type: uiTypes.NUMBER,

        validation: [],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "enabled",
      type: types.BOOLEAN,
      isArray: false,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        type: uiTypes.SWITCH,
        validation: [],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        type: uiTypes.DATE,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        type: uiTypes.DATE,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        type: uiTypes.TEXT,
        validation: [],
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
